import { render } from "./SelectorKPI.vue?vue&type=template&id=47c1d074&scoped=true"
import script from "./SelectorKPI.vue?vue&type=script&lang=js"
export * from "./SelectorKPI.vue?vue&type=script&lang=js"

import "./SelectorKPI.vue?vue&type=style&index=0&id=47c1d074&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c1d074"]])

export default __exports__